/**
 * 文字列を分割し、分割後の要素が空文字のものは取り除く
 * @param mark 分割する記号
 * @param items 連結された文字列
 */
export const filterSplitEmptyItem = (mark: string, items?: string) => {
  return items?.split(mark).filter((item) => item) || [];
};
